module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [(_vm.editMemo.id) ? _c('h3', [_vm._v(_vm._s('Vorgabe bearbeiten'))]) : _c('h3', [_vm._v(_vm._s('Neuen Dienst anlegen'))]), _vm._v(" "), (false) ? _c('div', [_vm._v("\n                idCompany: " + _vm._s(_vm.editMemo.idCompany) + "\n                idUser: " + _vm._s(_vm.editMemo.idUserClient) + "\n              ")]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_c('form', {
    attrs: {
      "id": _vm._uid
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('cancel', _vm.memo)
      },
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "memo-text"
    }
  }, [_vm._v("Wer hat Dienst / Beschreibung:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editMemo.text),
      expression: "editMemo.text"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "memo-text",
      "rows": "6",
      "placeholder": "Bitte eingeben..."
    },
    domProps: {
      "value": (_vm.editMemo.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editMemo, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    staticClass: "col-sm-6 form-group"
  }, [_c('label', {
    attrs: {
      "for": "memo-datetime-begin"
    }
  }, [_vm._v("Dienstbeginn")]), _vm._v(" "), _c('cc-datetime', {
    attrs: {
      "label_id": "memo-datetime-begin"
    },
    model: {
      value: (_vm.datetimeBegin),
      callback: function($$v) {
        _vm.datetimeBegin = $$v
      },
      expression: "datetimeBegin"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 form-group"
  }, [_c('label', {
    attrs: {
      "for": "memo-datetime-end"
    }
  }, [_vm._v("Dienstende:")]), _vm._v(" "), _c('cc-datetime', {
    attrs: {
      "label_id": "memo-datetime-end"
    },
    model: {
      value: (_vm.editMemo.datetimeEnd),
      callback: function($$v) {
        _vm.$set(_vm.editMemo, "datetimeEnd", $$v)
      },
      expression: "editMemo.datetimeEnd"
    }
  })], 1)]), _vm._v(" "), _c('br')])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "form": _vm._uid
    }
  }, [_vm._v("\n                Speichern\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('cancel', _vm.memo)
      }
    }
  }, [_vm._v("\n                Abbrechen\n              ")]), _vm._v(" "), (_vm.editMemo.id) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('remove', _vm.memo)
      }
    }
  }, [_vm._v("\n                Löschen\n              ")]) : _vm._e()])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3386ebf1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/MemoDienstModal.vue
// module id = 269
// module chunks = 0